import React, { useState } from 'react';
import {
    Button,
    Typography,
    Box,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    CircularProgress
} from '@mui/material';
import Editor from '@monaco-editor/react';

export const JobSubmission = ({
    mode,
    selectedTemplate,
    jobParam,
    handleTemplateChange,
    setJobParam,
    beautifyJobParam,
    submitJob
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmitJob = async () => {
        setIsSubmitting(true);
        try {
            await submitJob();
        } catch (error) {
            console.error('Job submission error:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Box
            sx={{
                padding: '1em',
                border: '1px solid #ccc',
                borderRadius: '15px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                backgroundColor: mode === 'light' ? '#f9f9f9' : '#424242',
                color: mode === 'light' ? '#000' : '#fff'
            }}
        >
            <Typography variant="h2" sx={{ fontSize: '1.5rem', marginBottom: '1em' }}>
                Submit Job
            </Typography>

            <FormControl component="fieldset" sx={{ marginBottom: '1em' }}>
                <FormLabel component="legend">Select JSON Template</FormLabel>
                <RadioGroup
                    row
                    value={selectedTemplate}
                    onChange={handleTemplateChange}
                >
                    <FormControlLabel
                        value="fit_template"
                        control={<Radio />}
                        label="Model Fit Template"
                    />
                    <FormControlLabel
                        value="attr_template"
                        control={<Radio />}
                        label="Attribution Template"
                    />
                    <FormControlLabel
                        value="target_max_template"
                        control={<Radio />}
                        label="Target Max Template"
                    />
                </RadioGroup>
            </FormControl>

            <Typography variant="body2" sx={{ marginBottom: '1em' }}>
                Enter the job params below. To get started, here's the selected job parameter template.
            </Typography>

            <Box sx={{ marginBottom: '1em' }}>
                <Typography variant="h3" sx={{ fontSize: '1.2rem', marginBottom: '1em' }}>
                    Job Parameters
                </Typography>
                <Editor
                    height="500px"
                    defaultLanguage="json"
                    value={jobParam}
                    onChange={(value) => setJobParam(value || '')}
                    options={{
                        minimap: { enabled: false },
                        fontSize: 14,
                        wordWrap: 'on',
                        scrollBeyondLastLine: false,
                        theme: mode === 'light' ? 'light' : 'vs-dark'
                    }}
                />
            </Box>

            <Box sx={{ display: 'flex', gap: '1em' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={beautifyJobParam}
                >
                    Beautify
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitJob}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? <CircularProgress size={24} /> : 'Submit Job'}
                </Button>
            </Box>
        </Box>
    );
};